<template>
  <div class="banner-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="btn" @click="handleBannerModal('add')">+ 添加轮播图</div>
        <!-- <span class="tip">轮播图最多上传5张</span> -->
        <el-table
          :data="bannerList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            type="index"
            :index="tableIndex"
            align="center"
            label="编号"
            width="120"
          ></el-table-column>
          <el-table-column prop="pic" align="center" label="轮播图片">
            <div slot-scope="scope">
              <img class="table-img" :src="scope.row.pic" alt="" />
            </div>
          </el-table-column>
          <el-table-column prop="way" align="center" label="链接类型">
            <div slot-scope="scope">
              {{ wayMap[scope.row.way] }}
            </div>
          </el-table-column>
          <el-table-column
            prop="name"
            align="center"
            label="关联产品/品牌主页"
          ></el-table-column>
          <el-table-column prop="orderBy" align="center" label="排序">
            <div slot-scope="scope" @click="changeSortModal(scope.row.id)">
              {{ scope.row.orderBy }}
            </div>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <div slot-scope="scope" style="display: flex">
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="handleBannerModal('edit', scope.row)"
                >
                  编辑
                </button>
              </div>
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deleteBanner(scope.row.id)"
                >
                  删除
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      :visible.sync="addBannerShow"
      class="dialog"
      width="560px"
      top="25vh"
    >
      <div slot="title" class="dialog-title">
        {{ (type === "add" ? "发布" : "编辑") + "轮播图" }}
      </div>
      <el-form
        ref="form"
        :rules="rules"
        :model="addBannerForm"
        class="banner-form"
        label-width="auto"
      >
        <el-form-item class="img_item" prop="pic" label="轮播图：">
          <div class="addImg">
            <p class="tips">推荐大小690px*280px</p>
            <div class="img-box">
              <img
                ref="img"
                :src="addBannerForm.pic"
                v-if="addBannerForm.pic"
              />
              <div class="icon" v-else>
                <p><i class="el-icon-plus" style="font-size: 24px"></i></p>
                <p>图片</p>
                <p class="tip">支持扩展名：.jpg .png</p>
              </div>
              <input
                type="file"
                class="file"
                ref="inputImg"
                accept="image/png, image/jpg, image/jpeg"
                @change="addChangeImg"
              />
            </div>
          </div>
        </el-form-item>

        <el-form-item label="跳转类型：" prop="gid" class="form-item">
          <el-select
            v-model="addBannerForm.way"
            class="add-renovation-input"
            style="width: 254px"
            size="mini"
            @change="changeWay"
            placeholder="请选择"
          >
            <el-option :value="1" label="商品"> </el-option>
            <el-option :value="3" label="品牌"> </el-option>
            <!-- <el-option :value="3" label="其他"> </el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item
          label="输入商品ID："
          prop="link"
          class="form-item"
          v-if="addBannerForm.way === 1"
        >
          <el-input
            size="mini"
            placeholder="请输入跳转商品的ID"
            class="add-renovation-input"
            v-model="addBannerForm.link"
            type="number"
            style="width: 254px"
            onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="输入文章链接："
          prop="link"
          class="form-item"
          v-if="addBannerForm.way === 2"
        >
        <el-input
            size="mini"
            placeholder="请输入跳转品牌的ID"
            class="add-renovation-input"
            v-model="addBannerForm.link"
            type="number"
            style="width: 254px"
            onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="输入品牌ID："
          prop="link"
          class="form-item"
          v-if="addBannerForm.way === 3"
        >
        <el-input
            size="mini"
            placeholder="请输入跳转品牌的ID"
            class="add-renovation-input"
            v-model="addBannerForm.link"
            type="number"
            style="width: 254px"
            onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序：" prop="sort" class="form-item">
          <el-input
            size="mini"
            placeholder="请输入序号"
            class="add-renovation-input"
            style="width: 160px"
            v-model.number="addBannerForm.orderBy"
            type="number"
            onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
          ></el-input>
          <div class="sort-tip">数值越大，排序越靠前</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="addBannerShow = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleBanner"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 修改排序弹窗 -->
    <el-dialog title="更改排序" width="400px" :visible.sync="sortShow">
      <el-form label-width="60px" size="mini" ref="editSort" inline-message>
        <el-form-item label="排序：" prop="tableData" style="margin-top: 15px">
          <el-input v-model="currentSort" type="number" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="sortShow = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="saveSort">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '轮播图设置'
      },
      bannerList: [], // 轮播列表
      rules: {},
      wayMap: {
        1: '商品',
        2: '文章',
        3: '品牌'
      },
      sortShow: false,
      currentSort: 0,
      addBannerForm: {
        pic: '',
        way: null,
        link: '',
        orderBy: null
      },
      addBannerShow: false,
      bannerId: null,
      type: '',
      bannerType: 1
    };
  },
  mounted() {
    // 获取列表
    this.getPlatformBannerList();
  },
  computed: {},
  methods: {
    // 表格序号
    tableIndex(index) {
      return ++index;
    },
    // 获取轮播列表
    getPlatformBannerList() {
      this.loading++;
      this.httpGet(this.$root.getPlatformBannerList, {
        bannerType: this.bannerType
      }).then(
        (res) => {
          this.loading--;
          this.bannerList = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 编辑轮播弹窗
    handleBannerModal(type, rowData) {
      // if (this.bannerList.length >= 5 && type === 'add') {
      //   this.$alert(
      //     `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>轮播图已达上限，无法新建！</p>`,
      //     {
      //       confirmButtonText: '确定',
      //       confirmButtonClass: 'confirm-btn',
      //       customClass: 'confirm-box',
      //       dangerouslyUseHTMLString: true,
      //       showClose: false,
      //       type: 'none'
      //     }
      //   );
      //   return;
      // }
      this.type = type;
      if (type === 'edit') {
        this.bannerId = rowData.id;
        this.addBannerForm = {
          pic: rowData.pic,
          way: rowData.way,
          link: rowData.link,
          orderBy: rowData.orderBy
        };
      } else {
        this.addBannerForm = {
          pic: '',
          way: null,
          link: '',
          orderBy: null
        };
        this.$refs.form && this.$refs.form.clearValidate();
      }
      this.addBannerShow = true;
    },
    changeWay() {
      this.addBannerForm.link = '';
    },
    // 删除轮播图
    deleteBanner(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该轮播吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deletePlatformBanner, {
          id,
          bannerType: this.bannerType
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getPlatformBannerList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 轮播
    handleBanner() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let url =
            this.type === 'add'
              ? this.$root.addPlatformBanner
              : this.$root.updatePlatformBanner;
          let method =
            this.type === 'add'
              ? 'httpPost'
              : 'httpPut';
          let inputData =
            this.type === 'add'
              ? {
                  ...this.addBannerForm,
                  bannerType: this.bannerType
                }
              : {
                  ...this.addBannerForm,
                  bannerType: this.bannerType,
                  id: this.bannerId
                };
          this.loading++;
          inputData.orderBy = +inputData.orderBy;
          this[method](url, inputData).then(
            (res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.loading--;
              this.addBannerShow = false;
              this.getPlatformBannerList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        }
      });
    },
    changeSortModal() {
      // this.sortShow = true;
    },
    // 图片改变
    addChangeImg(e) {
      this.upPic(e, (res) => {
        this.$set(this.addBannerForm, 'pic', res);
        // 清空input value，解决重复图片不触发change
        this.$refs.inputImg.value = '';
        this.$refs.form.clearValidate(['pic']);
      });
    },
    // 上传图片
    upPic(e, fun) {
      // 上传图片
      let file = e.target.files[0];
      if (!file) {
        return;
      }
      this.request.upPic({ prefix: 'other', file: file }).then(
        (res) => {
          fun(res);
        },
        (res) => {}
      );
    },
    saveSort() {}
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.banner-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        // width: 100px;
        display: inline-block;
        padding: 0 30px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        // margin: 16px 0;
      }

      .tip {
        margin-left: 32px;
        color: #40B98F;
      }

      // 表格按钮
      .table-btn {
        width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
      }

      .table-img {
        height: 70px;
        width: auto;
      }
    }
  }

  .dialog-content {
    flex-y();
  }

  .addImg {
    .icon {
      width: 270px;
      height: 108px;
    }
  }

  .banner-form {
    margin-top: 16px;
    margin-bottom: 80px;
    padding-left: 60px;

    .sort-tip {
      word(14px, #c8c8c8);
      line-height: 20px;
    }
  }
}
</style>
